import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Select from 'react-select';

interface SearchBarProps {
    placeholder?: string
    handleChange: (input: string, order: 'none' | 'ascending' | 'descending') => void
    sort?: boolean
}
export default function SearchBar({ placeholder = 'search', handleChange, sort = true }: SearchBarProps) {
    const { t } = useTranslation();
    placeholder = t(placeholder)

    const [input, setInput] = useState('');
    const [order, setOrder] = useState<'none' | 'ascending' | 'descending'>('ascending');

    const options: { value: ('none' | 'ascending' | 'descending'); label: React.ReactElement }[] = [
        {
            value: "none",
            label: (
                <div className="flex items-center" title={t('none')}>
                    <svg viewBox="0 0 24 24" className="w-6 h-6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.03001 8.03L7.25001 6.81V12.5C7.25001 12.91 7.59001 13.25 8.00001 13.25C8.41001 13.25 8.75001 12.91 8.75001 12.5V6.81L9.97001 8.03C10.12 8.18 10.31 8.25 10.5 8.25C10.69 8.25 10.88 8.18 11.03 8.03C11.32 7.74 11.32 7.26 11.03 6.97L8.53001 4.47C8.46001 4.4 8.38001 4.35 8.29001 4.31C8.11001 4.23 7.90001 4.23 7.72001 4.31C7.63001 4.35 7.55001 4.4 7.48001 4.47L4.98001 6.97C4.69001 7.26 4.69001 7.74 4.98001 8.03C5.27001 8.32 5.75001 8.32 6.04001 8.03H6.03001Z" fill="#000000"></path>
                        <path d="M17.97 15.97L16.75 17.19V11.5C16.75 11.09 16.41 10.75 16 10.75C15.59 10.75 15.25 11.09 15.25 11.5V17.19L14.03 15.97C13.74 15.68 13.26 15.68 12.97 15.97C12.68 16.26 12.68 16.74 12.97 17.03L15.47 19.53C15.54 19.6 15.62 19.65 15.71 19.69C15.8 19.73 15.9 19.75 16 19.75C16.1 19.75 16.2 19.73 16.29 19.69C16.38 19.65 16.46 19.6 16.53 19.53L19.03 17.03C19.32 16.74 19.32 16.26 19.03 15.97C18.74 15.68 18.26 15.68 17.97 15.97Z" fill="#000000"></path>
                        <path d="M19.03 6.03C19.32 5.74 19.32 5.26 19.03 4.97C18.74 4.68 18.26 4.68 17.97 4.97L16.75 6.19V5C16.75 4.59 16.41 4.25 16 4.25C15.59 4.25 15.25 4.59 15.25 5V7.69L4.97 17.97C4.68 18.26 4.68 18.74 4.97 19.03C5.12 19.18 5.31 19.25 5.5 19.25C5.69 19.25 5.88 19.18 6.03 19.03L7.25 17.81V19C7.25 19.41 7.59 19.75 8 19.75C8.41 19.75 8.75 19.41 8.75 19V16.31L19.03 6.03Z" fill="#000000"></path>
                    </svg>
                </div>
            )
        },
        {
            value: "ascending",
            label: (
                <div className="flex items-center" title={t('ascending')}>
                    <svg viewBox="0 0 24 24" className="w-6 h-6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.78 4.47C8.71 4.4 8.63 4.35 8.54 4.31C8.36 4.23 8.15 4.23 7.97 4.31C7.88 4.35 7.8 4.4 7.73 4.47L5.23 6.97C4.94 7.26 4.94 7.74 5.23 8.03C5.52 8.32 6 8.32 6.29 8.03L7.51 6.81V19C7.51 19.41 7.85 19.75 8.26 19.75C8.67 19.75 9.01 19.41 9.01 19V6.81L10.23 8.03C10.38 8.18 10.57 8.25 10.76 8.25C10.95 8.25 11.14 8.18 11.29 8.03C11.58 7.74 11.58 7.26 11.29 6.97L8.79 4.47H8.78Z" fill="#000000"></path>
                        <path d="M18.96 18.25L17.25 13.46C17.08 13.03 16.69 12.75 16.25 12.75C15.81 12.75 15.42 13.03 15.25 13.48L13.55 18.25C13.41 18.64 13.61 19.07 14 19.21C14.39 19.35 14.82 19.15 14.96 18.76L15.24 17.98H17.27L17.55 18.76C17.66 19.07 17.95 19.26 18.26 19.26C18.34 19.26 18.43 19.25 18.51 19.22C18.9 19.08 19.1 18.65 18.96 18.26V18.25ZM15.77 16.48L16.25 15.14L16.73 16.48H15.77Z" fill="#000000"></path>
                        <path d="M13.83 10.54C14.02 10.98 14.42 11.25 14.88 11.25H18.01C18.42 11.25 18.76 10.91 18.76 10.5C18.76 10.09 18.42 9.75001 18.01 9.75001H15.62L18.44 6.82001C18.78 6.46001 18.88 5.93001 18.68 5.47001C18.49 5.03001 18.09 4.76001 17.63 4.76001H14.52C14.11 4.76001 13.77 5.10001 13.77 5.51001C13.77 5.92001 14.11 6.26001 14.52 6.26001H16.91L14.08 9.21001C13.74 9.57001 13.65 10.09 13.84 10.55L13.83 10.54Z" fill="#000000"></path>
                    </svg>
                </div>
            )
        },
        {
            value: "descending",
            label: (
                <div className="flex items-center" title={t('descending')}>
                    <svg viewBox="0 0 24 24" className="w-6 h-6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.22 15.97L9 17.19V5C9 4.59 8.66 4.25 8.25 4.25C7.84 4.25 7.5 4.59 7.5 5V17.19L6.28 15.97C5.99 15.68 5.51 15.68 5.22 15.97C4.93 16.26 4.93 16.74 5.22 17.03L7.72 19.53C7.79 19.6 7.87 19.65 7.96 19.69C8.05 19.73 8.15 19.75 8.25 19.75C8.35 19.75 8.44 19.73 8.54 19.69C8.63 19.65 8.71 19.6 8.78 19.53L11.28 17.03C11.57 16.74 11.57 16.26 11.28 15.97C10.99 15.68 10.51 15.68 10.22 15.97Z" fill="#000000"></path>
                        <path d="M18.96 18.25L17.25 13.46C17.08 13.03 16.69 12.75 16.25 12.75C15.81 12.75 15.42 13.03 15.25 13.48L13.55 18.25C13.41 18.64 13.61 19.07 14 19.21C14.39 19.35 14.82 19.15 14.96 18.76L15.24 17.98H17.27L17.55 18.76C17.66 19.07 17.95 19.26 18.26 19.26C18.34 19.26 18.43 19.25 18.51 19.22C18.9 19.08 19.1 18.65 18.96 18.26V18.25ZM15.77 16.48L16.25 15.14L16.73 16.48H15.77Z" fill="#000000"></path>
                        <path d="M13.83 10.54C14.02 10.98 14.42 11.25 14.88 11.25H18.01C18.42 11.25 18.76 10.91 18.76 10.5C18.76 10.09 18.42 9.75001 18.01 9.75001H15.62L18.44 6.82001C18.78 6.46001 18.88 5.93001 18.68 5.47001C18.49 5.03001 18.09 4.76001 17.63 4.76001H14.52C14.11 4.76001 13.77 5.10001 13.77 5.51001C13.77 5.92001 14.11 6.26001 14.52 6.26001H16.91L14.08 9.21001C13.74 9.57001 13.65 10.09 13.84 10.55L13.83 10.54Z" fill="#000000"></path>
                    </svg>
                </div>

            )
        }
    ];

    const [selectedOption, setSelectedOption] = useState<{ value: ('none' | 'ascending' | 'descending'); label: React.ReactElement }>(options[1]);

    useEffect(() => {
        const option = options.find(o => o.value === order);
        if (option == null) return;
        setSelectedOption(option);
    }, [order])

    useEffect(() => {
        handleChange(input, order);
    }, [order, input])


    return (
        <div className="w-full mr-2">
            <div className="mt-1">
                <div className="min-h-9 flex items-center rounded-md bg-white pl-3 outline outline-1 -outline-offset-1 outline-gray-300 has-[input:focus-within]:outline has-[input:focus-within]:outline-2 has-[input:focus-within]:-outline-offset-2 has-[input:focus-within]:outline-indigo-600">
                    <svg className="w-3 h-3 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                    </svg>
                    <input
                        type="text"
                        name="search"
                        id="search"
                        value={input}
                        className="block min-w-0 grow py-0.5 pl-2 pr-3 text-base text-gray-900 placeholder:text-gray-400 focus:outline focus:outline-0 sm:text-sm/6"
                        placeholder={placeholder}
                        onChange={e => setInput(e.target.value)}
                    />
                    {sort &&
                        <div className="grid shrink-0 grid-cols-1 border-l">
                            <Select
                                name="sort"
                                id="sort"
                                options={options}
                                onChange={e => setOrder(e ? e.value : order)}
                                value={selectedOption}
                                className="select_sort h-9"
                                classNamePrefix="select"
                                isSearchable={false}
                                components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                                styles={{
                                    control: (base, props) => ({
                                        height: '100%',
                                        paddingTop: '0.25rem'
                                    })
                                }}
                            />
                        </div>
                    }
                </div>
            </div>
        </div>
    );
}
